<script setup lang="ts">
// composables
const router = useRouter()

// stores
const appStore = useAppStore()
const authStore = useAuthStore()
const guideStore = useGuideStore()

// refs
const { dialog } = storeToRefs(guideStore)

// computed
const { user } = storeToRefs(authStore)
const btnText = computed(() => user.value?.FullName || '')
const isAuthenticated = computed(() => authStore?.isAuthenticated)

// methods
async function logout() {
  if (isAuthenticated.value) {
    await authStore.logout()
    router.push('/')
    appStore.setSnackbar({
      active: true,
      message: 'You Have Been Logged Out',
      timeout: 3000,
      type: 'info',
    })
  }
}
</script>

<template>
  <v-btn
    class="text-capitalize text-subtitle-1 font-weight-medium h-100 pl-5 mr-2"
    data-cy="menu-account"
  >
    {{ btnText }}
    <v-icon
      class="ml-2"
      icon="$mdiChevronDown"
    />

    <v-menu
      activator="parent"
      transition="slide-y-transition"
    >
      <v-list
        class="pb-1"
        slim
      >
        <v-list-item
          prepend-icon="$mdiHelpCircleOutline"
          title="Guides"
          @click="dialog = true"
        />

        <v-list-item
          prepend-icon="$mdiCog"
          title="Settings"
          to="/settings"
        />
        <v-divider class="my-1" />
        <v-list-item
          data-cy="menu-account-logout"
          prepend-icon="$mdiLogout"
          title="Logout"
          @click="logout"
        />
      </v-list>
    </v-menu>
    <DialogGuides />
  </v-btn>
</template>
